import { defineMessages } from '@cookbook/solid-intl'

export const messages = defineMessages({
    closeAriaLabel: {
        defaultMessage: 'Close',
        id: 'BannerMoleculeComponent.closeAriaLabel',
    },
})
